import { render, staticRenderFns } from "./Boundary.vue?vue&type=template&id=24407d0a&scoped=true"
import script from "./Boundary.vue?vue&type=script&lang=js"
export * from "./Boundary.vue?vue&type=script&lang=js"
import style0 from "./Boundary.vue?vue&type=style&index=0&id=24407d0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24407d0a",
  null
  
)

export default component.exports